import { useCommunityContext } from '@/providers/community-context';
import { PointsDashboardView } from '@/pages/dashboard/components/points-dashboard-view';
import { Loader2 } from 'lucide-react';

export default function PointsDashboardPage() {
  const { community: currentCommunity, isLoading } = useCommunityContext();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
      </div>
    );
  }

  if (!currentCommunity) {
    return (
      <div className="text-center py-20">
        <h2 className="text-2xl font-bold text-foreground">Community not found</h2>
        <p className="text-muted-foreground">The community you are looking for does not exist.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold tracking-tight text-foreground">Points Dashboard</h2>
      <PointsDashboardView />
    </div>
  );
}
